import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import { FlatRowCombobox } from "web_myplann/Shared/Components/FlatRow/FlatRowCombobox";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

type Props<
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
	name: TName;
	label: string;
	options: FlatRowSelectOption<string>[];
	drawerTitle?: string;
	placeholder?: string;
	searchPlaceholder?: string;
	isLast?: boolean;
	isLoading?: boolean;
};

export const FlatRowFormCombobox = <
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	label,
	options,
	drawerTitle,
	placeholder,
	searchPlaceholder,
	isLast,
	isLoading,
}: Props<FormType, TName, TContext, TTransformed>) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({
				field: { value, onChange, onBlur },
				fieldState: { error },
			}) => (
				<FlatRowCombobox
					label={label}
					value={(value ?? "") as string}
					options={options}
					onChange={onChange}
					onBlur={onBlur}
					drawerTitle={drawerTitle}
					placeholder={placeholder}
					searchPlaceholder={searchPlaceholder}
					isLast={isLast}
					isLoading={isLoading}
					error={!!error?.message}
					helperText={error?.message}
				/>
			)}
		/>
	);
};
